import { render } from "./YobouLogTable.vue?vue&type=template&id=13a1cb50&scoped=true"
import script from "./YobouLogTable.vue?vue&type=script&lang=js"
export * from "./YobouLogTable.vue?vue&type=script&lang=js"

import "./YobouLogTable.vue?vue&type=style&index=0&id=13a1cb50&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a1cb50"]])

export default __exports__